import axios from 'axios';
export function getTranscriptionData(roomId, skip)
{
	return new Promise((resolve, reject) =>
	{
		axios.get(`${import.meta.env.VITE_SHEDULE}/gettranscription/${roomId}?skip=${skip}&limit=10&sort=-1`)
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}